module.exports = __webpack_public_path__ + "img/6.ad7cb976.png";